import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../utils/cn';
const circleVariants = cva('rounded-full', {
  variants: {
    size: {
      default: 'size-4',
      xs: 'size-1',
      sm: 'size-2',
      lg: 'size-5'
    },
    color: {
      default: 'bg-primary',
      valid: 'bg-success-foreground',
      error: 'bg-destructive-foreground',
      warning: 'bg-warning',
      info: 'bg-info'
    }
  },
  defaultVariants: {
    size: 'default',
    color: 'default'
  }
});
export type CircleProps = React.ComponentProps<'div'> & VariantProps<typeof circleVariants> & React.PropsWithChildren;
function Circle(t0) {
  const $ = _c(12);
  let className;
  let color;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      className,
      size,
      color,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = color;
    $[3] = props;
    $[4] = size;
  } else {
    className = $[1];
    color = $[2];
    props = $[3];
    size = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== color || $[7] !== size) {
    t1 = cn(circleVariants({
      size,
      color,
      className
    }));
    $[5] = className;
    $[6] = color;
    $[7] = size;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props || $[10] !== t1) {
    t2 = <div data-slot="circle" className={t1} {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export { Circle };